/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react';
// import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import Image from 'next/image';
import HorizontalScroll from './HorizontalScroll';
import playCircle from '../../../public/assets/playCircle.png';
import ViewAllButton from '../home/course-section/ViewAllButton';
import VideoPopup from './VideoPopup';
import NoDataFound from './NoDataFound';
import BreadCrumb from '../home/header/BreadCrumb';
import { formatSecondsToDynamicTime } from '../../utils/helpers';
import { trackEvent } from '../../utils/analytics';
// import { useUser } from '../../contexts/ssr-user-context';
import EventNames from '../../utils/event-name-constants';

function VideoCard({
  sectionTitle, videoData, entityID, page, pageType = 1, pageSlug,
}) {
  // const router = useRouter();
  const queryString = sectionTitle.toLowerCase().replace(/\s+/g, '-');
  const pageUrl = `/view-all/${entityID}`;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState(null);
  const { FREE_VIDEO_CLICKED } = EventNames;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getVideoIDFromYtUrl = (url) => {
    // eslint-disable-next-line no-useless-escape
    const videRegEx = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    // console.log('id ', url.match(videRegEx)[1])
    return url.match(videRegEx)[1];
  };

  const openModal = (video) => {
    trackEvent(FREE_VIDEO_CLICKED, {
      listId: entityID,
      listTitle: sectionTitle,
      videoId: video?.id,
      videoTitle: video?.name,
      screenName: 'Home',
    });
    const id = getVideoIDFromYtUrl(video?.url);
    const youtubeEmbedURL = `https://www.youtube.com/embed/${id}?autoplay=1`;
    setCurrentVideoUrl(youtubeEmbedURL);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentVideoUrl(null);
  };

  const initialData = () => (
    <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-3 md:grid-cols-2 xl:grid-cols-3 gap-6">
      { videoData?.length > 0 ? (
        videoData?.map((video) => (
          <div
            className="border border-blue-200 rounded-lg p-1
         flex w-full justify-center items-center lg:block lg:w-[322px] overflow-hidden flex-shrink-0 bg-white"
            key={video?.id}
          >
            <div className="flex relative lg:w-auto w-[40%]">
              <Image width={500} height={500} src={video?.thumbnail} alt="teacher-banner" className="self-start w-full lg:h-36 rounded lg:rounded-none lg:rounded-tl-lg lg:rounded-tr-lg" />
              <div className="flex absolute rounded lg:rounded-lg  top-0 left-0 w-100 h-100 bg-slate-700/40 min-w-full min-h-full items-center justify-center">
                <Image
                  src={playCircle}
                  width={48}
                  height={48}
                  alt="play-button"
                  className="w-8 lg:w-12
                 absolute cursor-pointer"
                  onClick={() => openModal(video)}
                />
                <span className="bg-black/90 self-end absolute right-1 bottom-1 text-white px-1 text-sm font-medium">{formatSecondsToDynamicTime(video?.duration)}</span>
              </div>
            </div>
            <div className="lg:py-3 px-2 lg:w-auto  w-[60%]">
              <span className="w-full text-sm font-semibold lg:line-clamp-2 text-greyFont">
                {video?.name}
              </span>
            </div>
          </div>

        ))) : (
          <div className="grid grid-cols-1 gap-4 min-h-80">
            {videoData?.getListContents?.contents.length < 1 && <NoDataFound noMsg="No Data Found " />}
          </div>
      )}
    </div>
  );

  if (pageType === '2') {
    return (
      <div className="lg:p-0 px-4">
        {isModalOpen && <VideoPopup videoUrl={currentVideoUrl} onClose={closeModal} />}
        <BreadCrumb type={2} />
        <div className="flex flex-wrap gap-5 text-xs font-medium lg:font-semibold lg:text-base">
          <div className={`${videoData?.length < 1 ? 'w-full flex justify-center' : 'flex gap-[14px] lg:gap-6 flex-wrap'}`}>
            {initialData()}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="">
      {isModalOpen && <VideoPopup videoUrl={currentVideoUrl} onClose={closeModal} />}
      <div className="flex justify-between mb-4 lg:mb-7 items-center pr-5 lg:pr-0">
        <div className="xl:text-2xl text-lg font-semibold capitalize">{sectionTitle}</div>
        <ViewAllButton
          pageType={pageSlug === 'daily-news-analysis' ? 'dna' : ''}
          pageUrl={pageUrl}
          queryString={`page=${queryString}`}
          typeButton={2}
          hiddenLgBTn={false}
          pageTitle={page}
        />
      </div>
      <HorizontalScroll className="scrollbar-hide">

        <ul className={`flex flex-shrink-0 gap-4 w-full text-xs font-medium lg:font-semibold 
        lg:text-base ${!videoData?.length ? 'justify-center' : ''} `}
        >
          { videoData?.length > 0 ? (
            videoData.map((video) => (
              <li className="border border-blue-200 bg-white rounded-lg lg:p-[6px] w-[160px] lg:w-[322px] flex-shrink-0" key={video?.id}>
                <div className="flex relative ">
                  <Image width={500} height={500} src={video?.thumbnail} alt="teacher-banner" className="self-start w-80 lg:h-36 rounded lg:rounded-tl-lg lg:rounded-tr-lg aspect-[31/18]" />
                  <div className="flex absolute top-0 left-0 w-100 h-100 bg-slate-700/40 min-w-full min-h-full items-center  rounded-tl-lg rounded-tr-lg justify-center">
                    <Image
                      width={48}
                      height={48}
                      src={playCircle}
                      alt="play-button"
                      className="w-12
                       absolute cursor-pointer"
                      onClick={() => openModal(video)}
                    />
                    <span className="bg-black/90 self-end absolute right-1 bottom-1 text-white px-1 text-sm font-medium">
                      {formatSecondsToDynamicTime(video?.duration)}
                    </span>
                  </div>
                </div>
                <div className="py-3 px-2">
                  <span className="text-greyFont rounded-sm lg:text-base text-xs font-medium line-clamp-2">
                    {' '}
                    {video?.name}
                  </span>
                </div>
              </li>

            ))) : (
              <li className="w-full">
                {/* <h2 className="text-red-600">{error?.message}</h2> */}
                {/* <div className="xl:text-2xl text-lg font-semibold">{removeDashFromString(page)}</div> */}
                <NoDataFound noMsg="No Videos found" />
              </li>
          )}
        </ul>
      </HorizontalScroll>
      {/* <hr className="border-2 my-[22px] border-[#E2E8F0] block xl:hidden  absolute right-0 left-0" /> */}

    </div>
  );
}
VideoCard.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  videoData: PropTypes.array.isRequired,
};

export default VideoCard;
